import axios from "axios";

//@ts-expect-error
export const BASE_URL = window.ENV?.REACT_APP_BASE_API ?? '';

export const BASE_URL_USER = "https://dss-customer-glue-service-emedbkgp-qa.apps.dev.aks.forgeapp.honeywell.com";

export const csrfTokenApis: Record<string, string> = {
    customer: `${BASE_URL}/customer/csrf-token`,
        indsapi: `${BASE_URL}/customer/csrf-token`,
    pim: `${BASE_URL}/pim/csrf-token`,
    users: `${BASE_URL}/customer/csrf-token`,
    osm: `${BASE_URL}/customer/csrf-token`,
    shipment: `${BASE_URL}/shipment/csrf-token`,
    subscription: `${BASE_URL}/customer/csrf-token`,
    common: `${BASE_URL}/customer/csrf-token`,
};

export const getCSRFModule = (url?: string): keyof typeof csrfTokenApis | null => {

    if (!url) return null;
    return Object.keys(csrfTokenApis).find((module) => url.includes(`${module}/`)) as keyof typeof csrfTokenApis || null;
};

export const fetchCSRFToken = async (module: keyof typeof csrfTokenApis) => {
    try {
        const response = await axios.get(csrfTokenApis[module], {
            headers: {
                module,
            },
            withCredentials: true,
        });
        return response.data;
    } catch (error) {
        console.error(`Failed to fetch CSRF token for ${module}`, error);
        return null;
    }
};
